(function () {
  'use strict';

  var form = document.getElementById('supportForm');
  if (!form) return;

  var subject = form.querySelector('[data-support-subject]');
  var orderIdGroup = form.querySelector('[data-support-group="order-id"]');
  var orderIdInput = form.querySelector('[data-support-order-id]');
  var complaintGroup = form.querySelector('[data-support-group="complaint"]');
  var complaintSelect = form.querySelector('[data-support-complaint]');
  var screenshotGroup = form.querySelector('[data-support-group="screenshot"]');
  var screenshotInput = form.querySelector('[data-support-screenshot]');
  var messageField = form.querySelector('[data-support-message]');
  var honeypot = form.querySelector('.support-form__honeypot');
  var recaptchaEl = form.querySelector('[data-support-recaptcha]');
  var recaptchaWidgetId = null;

  var ORDER_SUBJECTS = [
    'Order Related',
    'Song URL Change Request',
    'Refund Request',
    'Song URL Change Request (Ad)'
  ];

  var COMPLAINT_SUBJECTS = ['Complaints', 'Complaints (Ad)'];

  function isAdComplaint() {
    return subject && subject.value === 'Complaints (Ad)';
  }

  function syncComplaintOptions() {
    if (!complaintSelect) return;
    var adGroup = complaintSelect.querySelector('[data-support-complaint-group="ad"]');
    var playlistGroup = complaintSelect.querySelector('[data-support-complaint-group="playlist"]');
    if (adGroup) adGroup.hidden = !isAdComplaint();
    if (playlistGroup) playlistGroup.hidden = isAdComplaint();
    if (complaintSelect.value) {
      var selected = complaintSelect.selectedOptions[0];
      if (selected && selected.closest('optgroup') && selected.closest('optgroup').hidden) {
        complaintSelect.value = '';
      }
    }
  }

  function setGroupVisible(group, input, visible, required) {
    if (!group) return;
    group.hidden = !visible;
    if (input) {
      input.required = visible && required;
      if (!visible) input.value = '';
    }
  }

  function updateFields() {
    var value = subject ? subject.value : '';
    var needsOrderId = ORDER_SUBJECTS.indexOf(value) !== -1 || COMPLAINT_SUBJECTS.indexOf(value) !== -1;
    var needsComplaint = COMPLAINT_SUBJECTS.indexOf(value) !== -1;
    var needsScreenshot = needsComplaint && complaintSelect && complaintSelect.value === 'Low Streams';

    setGroupVisible(orderIdGroup, orderIdInput, needsOrderId, true);
    setGroupVisible(complaintGroup, complaintSelect, needsComplaint, true);
    syncComplaintOptions();
    setGroupVisible(screenshotGroup, screenshotInput, needsScreenshot, true);
  }

  function enrichMessageBody() {
    if (!messageField || messageField.dataset.enriched === 'true') return;

    var lines = [];
    if (subject && subject.value) lines.push('Subject: ' + subject.value);
    if (orderIdInput && orderIdInput.value.trim()) lines.push('Order ID: ' + orderIdInput.value.trim());
    if (complaintSelect && complaintSelect.value) lines.push('Type of Complaint: ' + complaintSelect.value);

    if (screenshotInput && screenshotInput.files && screenshotInput.files.length) {
      var names = Array.prototype.map.call(screenshotInput.files, function (file) {
        return file.name + ' (' + Math.round(file.size / 1024) + ' KB)';
      });
      lines.push('Screenshot(s): ' + names.join(', '));
      lines.push('Note: Reply to this thread with attachments if screenshots did not upload.');
    }

    var existing = messageField.value.trim();
    if (lines.length) {
      messageField.value = lines.join('\n') + (existing ? '\n\n---\n\n' + existing : '');
    }

    messageField.dataset.enriched = 'true';
  }

  function initInvisibleRecaptcha() {
    if (!recaptchaEl || !window.grecaptcha || recaptchaWidgetId !== null) return;

    var sitekey = recaptchaEl.getAttribute('data-sitekey');
    if (!sitekey) return;

    recaptchaWidgetId = window.grecaptcha.render(recaptchaEl, {
      sitekey: sitekey,
      size: 'invisible',
      badge: 'bottomright',
      callback: function () {
        enrichMessageBody();
        form.submit();
      },
      'error-callback': function () {
        form.classList.add('support-form--recaptcha-error');
      },
      'expired-callback': function () {
        if (recaptchaWidgetId !== null) {
          window.grecaptcha.reset(recaptchaWidgetId);
        }
      }
    });
  }

  window.supportRecaptchaOnLoad = function () {
    initInvisibleRecaptcha();
  };

  if (subject) subject.addEventListener('change', updateFields);
  if (complaintSelect) complaintSelect.addEventListener('change', updateFields);
  updateFields();

  form.addEventListener('submit', function (event) {
    if (honeypot && honeypot.value.trim() !== '') {
      event.preventDefault();
      return;
    }

    if (form.dataset.preview === 'true') {
      event.preventDefault();
      var notice = form.querySelector('.support-form__notice--success');
      if (notice) {
        notice.hidden = false;
        notice.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      return;
    }

    enrichMessageBody();

    if (recaptchaEl && window.grecaptcha && recaptchaWidgetId !== null) {
      event.preventDefault();
      form.classList.remove('support-form--recaptcha-error');
      window.grecaptcha.execute(recaptchaWidgetId);
      return;
    }
  });

  if (window.grecaptcha && window.grecaptcha.render) {
    initInvisibleRecaptcha();
  }
})();
